import { render, staticRenderFns } from "./StatusMandatoEdit.vue?vue&type=template&id=0e4bb35b&scoped=true&"
import script from "./StatusMandatoEdit.vue?vue&type=script&lang=js&"
export * from "./StatusMandatoEdit.vue?vue&type=script&lang=js&"
import style0 from "./StatusMandatoEdit.vue?vue&type=style&index=0&id=0e4bb35b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4bb35b",
  null
  
)

export default component.exports